const home = {
  zh: {
    connectLabel: "请输入云码",
    tipsConnecting: "等待连接中...",
    tipsConnected: "已连接",
    recordLabel: "一键投屏",
    textInputVerificationCode: "请输入验证码",
    textAuthorize: "等待授权中...",
    textPause: "暂停投屏",
    textSharing: "正在投屏至 ",
    pauseResumeLabel: "恢复投屏",
    recordStopLabel: "结束投屏",
    toDownloadLabel: "下载应用程序",
    title: "无线投屏",
    deviceName: "本机设备名称",
    language: "语言",
    codeInvalid: "云码无效",
    pluginError: "加载插件失败，请重试",
    serverError: "连接服务异常，请检查网络连接后重试",
    inputMsg: "请输入信息",
    codeError: "验证码错误，请重新输入",
    timeout: "请求超时",
    userCancel: "无法获取投屏权限",
    confirm: "确定",
    refused: "接收端拒绝了投屏请求",
    kicked: "你已被接收端踢出",
    disconnect: "连接已断开",
    notice: "提示",
    unsurport: "该浏览器不支持投屏，请更新版本或使用其他浏览器",
    maxTime: "已达到最大尝试次数",
    maxPublishers: "已达到最大投屏数",
  },
  zh_rTW: {
    connectLabel: "請輸入雲碼",
    tipsConnecting: "等待連接中...",
    tipsConnected: "已連接",
    recordLabel: "一鍵投屏",
    textInputVerificationCode: "請輸入驗證碼",
    textAuthorize: "等待授權中...",
    textPause: "暫停投屏",
    textSharing: "正在投屏至 ",
    pauseResumeLabel: "恢復投屏",
    recordStopLabel: "結束投屏",
    toDownloadLabel: "下載應用程序",
    title: "無線投屏",
    deviceName: "本機設備名稱",
    language: "語言",
    codeInvalid: "雲碼無效",
    pluginError: "加載挿件失敗，請重試",
    serverError: "連接服務异常，請檢查網絡連接",
    inputMsg: "請輸入內容",
    codeError: "驗證碼錯誤，請重新輸入",
    timeout: "請求超時",
    userCancel: "無法獲取投屏許可權",
    confirm: "確定",
    refused: "接收端拒絕了投屏請求",
    kicked: "你已被接收端踢出",
    disconnect: "連接已斷開",
    notice: "提示",
    unsurport: "該瀏覽器不支持投屏，請更新版本或使用其他瀏覽器",
    maxTime: "已達到最大嘗試次數",
    maxPublishers: "已達到最大投屏數",
  },
  en: {
    connectLabel: "Please enter the cloud code",
    tipsConnecting: "Waiting to connect...",
    tipsConnected: "Connected",
    recordLabel: "Cast",
    textInputVerificationCode: "Please enter the verification code",
    textAuthorize: "Waiting for authorization...",
    textPause: "Pause",
    textSharing: "Projecting to ",
    pauseResumeLabel: "Resume",
    recordStopLabel: "Close",
    toDownloadLabel: "Download",
    title: "Screen Sharring",
    deviceName: "Device name",
    language: "Language",
    codeInvalid: "Invalid cloud code",
    pluginError: "Loading plugin failed, please try again",
    serverError: "Connection service exception, please check network connection and try again",
    inputMsg: "Please enter information",
    codeError: "Verification code error, please re-enter",
    timeout: "Request timeout",
    userCancel: "Unable to obtain screen mirroring permission",
    confirm: "Confirm",
    refused: "The receiving end rejected the screen casting request",
    kicked: "You have been kicked out by the receiving end",
    disconnect: "Connection dropped",
    notice: "Tips",
    unsurport: "This browser does not support screen mirroring. Please update the version or use another browser",
    maxTime: "The maximum number of attempts has been reached",
    maxPublishers: "Maximum number of publishers already reached",
  },
}

export default home;
